/**
 * src/components/agent/ChatSidebarV2.styles.js — Sidebar styles.
 *
 * Phase 82-03 — Chat System Unification.
 *
 * Tokens only (src/styles.js) per HARD DEPLOYMENT RULES.
 */

export const rootStyle = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  minHeight: 0,
  background: 'var(--glass)',
};

export const headerStyle = {
  padding: 12,
  borderBottom: '1px solid var(--bdr)',
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
  flexShrink: 0,
};

export const newChatBtnStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  width: '100%',
  minHeight: 44,
  padding: '8px 12px',
  borderRadius: 10,
  border: 'none',
  background: 'var(--accent)',
  color: 'var(--on-accent, #FFF)',
  fontSize: 14,
  fontWeight: 600,
  cursor: 'pointer',
  fontFamily: 'inherit',
};

export const filterPillStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  width: '100%',
  minHeight: 36,
  padding: '6px 12px',
  borderRadius: 999,
  border: '1px solid var(--bdr)',
  background: 'var(--bg, var(--glass))',
  color: 'var(--t1)',
  fontSize: 12,
  fontWeight: 500,
  cursor: 'pointer',
  fontFamily: 'inherit',
};

export const filterPillLabelStyle = {
  flex: 1,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  textAlign: 'left',
};

export const filterPopoverStyle = {
  position: 'absolute',
  top: '100%',
  left: 0,
  right: 0,
  marginTop: 4,
  zIndex: 1100,
  background: 'var(--card, var(--bg))',
  border: '1px solid var(--bdr)',
  borderRadius: 10,
  boxShadow: 'var(--shc)',
  maxHeight: 280,
  overflowY: 'auto',
  padding: '4px 0',
};

export const filterOptionStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  width: '100%',
  minHeight: 44,
  padding: '8px 12px',
  fontSize: 13,
  fontWeight: 500,
  color: 'var(--t1)',
  background: 'transparent',
  border: 'none',
  cursor: 'pointer',
  fontFamily: 'inherit',
  textAlign: 'left',
};

/* TICKET-107 (b) — sticky type-to-search header inside the filter popover. */
export const filterSearchWrapStyle = {
  position: 'sticky',
  top: 0,
  zIndex: 1,
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  padding: '6px 12px',
  background: 'var(--card, var(--bg))',
  borderBottom: '1px solid var(--bdr)',
};

export const filterSearchInputStyle = {
  flex: 1,
  minWidth: 0,
  minHeight: 44,
  border: 'none',
  outline: 'none',
  background: 'transparent',
  color: 'var(--t1)',
  fontSize: 13,
  borderRadius: 8,
  fontFamily: 'inherit',
};

export const filterEmptyStyle = {
  padding: '12px',
  fontSize: 12,
  color: 'var(--tm)',
  textAlign: 'center',
};

/* TICKET-233 — group header inside the unified scope filter popover
   (Projects / Pipeline / Tasks / People). */
export const filterSectionHeaderStyle = {
  padding: '8px 12px 4px',
  fontSize: 10,
  fontWeight: 700,
  letterSpacing: 0.5,
  textTransform: 'uppercase',
  color: 'var(--tm)',
};

export const filterOptionActiveStyle = {
  ...filterOptionStyle,
  background: 'var(--accent-bg)',
  color: 'var(--accent)',
  fontWeight: 600,
};

export const listWrapStyle = {
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
  padding: '8px 4px',
};

export const groupHeaderStyle = {
  padding: '6px 12px',
  fontSize: 11,
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  color: 'var(--tm)',
};

export const accordionBtnStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  width: '100%',
  minHeight: 36,
  padding: '6px 12px',
  border: 'none',
  background: 'transparent',
  color: 'var(--tm)',
  fontSize: 11,
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  cursor: 'pointer',
  textAlign: 'left',
  fontFamily: 'inherit',
};

export const emptyGroupStyle = {
  padding: '4px 12px 8px',
  fontSize: 12,
  color: 'var(--tm)',
  fontStyle: 'italic',
};

export const loadingStyle = {
  padding: 16,
  color: 'var(--tm)',
  fontSize: 13,
  textAlign: 'center',
};

export const errorStyle = {
  padding: 12,
  margin: '8px 12px',
  background: 'var(--bad-tint)',
  color: 'var(--bad)',
  border: '1px solid var(--bad)',
  borderRadius: 8,
  fontSize: 12,
};

export const closeBtnStyle = {
  minWidth: 44,
  minHeight: 44,
  width: 44,
  height: 44,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: 'none',
  background: 'transparent',
  color: 'var(--t1)',
  cursor: 'pointer',
  borderRadius: 8,
  padding: 0,
};
